import { DateRangeOption } from './filter-data';

export interface Reports {
    id?: string;
    name: string;
    reportType: Number;
    studyGroupName: string[];
    protocolCode: string[];
    params: any;
    filterContent?: string;
    reportAction: ReportAction;
    reportRunTime?: string;
    dateRange?: DateRangeOption;
    filterJSON?: any;
    configJSON?: any;
    appDataDefinitionId?: number;
    isGeneratedNotSavedReport: boolean;
}

export enum ReportAction {
    GeneratedNotSaved,
    NotGeneratedSaved,
    GeneratedSaved,
}

export interface ScheduleReport {
    id?: string;
    name: string;
    reportType: Number;
    studyGroupName: string[];
    protocolCode: string[];
    params: {};
    reoccurencePattern: string;
    scheduleParams: {};
    scheduleRunTime: string;
}